import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '../../shared/reactSelect/select.component';
import { connect } from 'react-redux';
import PeriodDropdown from '../../shared/periodDropdown.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import { periodsSelector, connectionsOptionsSelector } from '../../shared/store/selectors';
import {
  fetchInitialDataForConnectionRunStatusPage,
  selectPeriodForConnectionRunStatus,
  selectConnectionForConnectionRunStatus,
} from './store/actions';

import { fetchHeartbeatMonitorStatus } from '../store/actions';

import { filterSelectFactory } from '../../utils/dropdownsHelpers';
import { byFieldUpperCase } from '../../utils/sorting';

import ConnectionRunStatusGridDashboard from './connectionRunStatusDashboard.component';
import ConnectionRunStatusGrid from './connectionRunStatusGrid.component';
import ConnectionRunStatusGridHeader from './connectionRunStatusHeader.component';

const filterSelectDefault = filterSelectFactory();

class ConnectionRunStatusDashboardPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    connections: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
    connection: PropTypes.shape({
      connName: PropTypes.string,
      value: PropTypes.string,
    }),
    lastUpdated: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    fetchInitialDataForConnectionRunStatusPage: PropTypes.func.isRequired,
    selectPeriodForConnectionRunStatus: PropTypes.func.isRequired,
    selectConnectionForConnectionRunStatus: PropTypes.func.isRequired,
    fetchHeartbeatMonitorStatus: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.fetchInitialDataForConnectionRunStatusPage();
    this.props.fetchHeartbeatMonitorStatus();
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.connection !== this.props.connection) || (prevProps.period !== this.props.period)) {
      this.props.fetchHeartbeatMonitorStatus();
    }
  }

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    const period = periods.find(period => period.name === value);

    this.props.selectPeriodForConnectionRunStatus(period);
  };

  selectConnection = selectedConnection => {
    const connection = selectedConnection ? selectedConnection.value : null;

    this.props.selectConnectionForConnectionRunStatus(connection);
  };

  render() {
    const {
      connection,
      connections,
      lastUpdated,
      fetchInitialDataForConnectionRunStatusPage,
    } = this.props;

    const selectedConnection = connection ? connection.connName : '';
    const sortedConnections = connections.filter(connection => connection.value !== 'ALL').sort(byFieldUpperCase('label'));
    return (
      <div className="connection-run-status-dashboard-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          <Select
            clearable={false}
            filterOptions={filterSelectDefault}
            name="connection"
            options={sortedConnections}
            onChange={this.selectConnection}
            scrollMenuIntoView={false}
            value={selectedConnection}
            className="select-connection"
            virtualized
          />
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <ConnectionRunStatusGridHeader
                  refreshAction={fetchInitialDataForConnectionRunStatusPage}
                  lastUpdated={lastUpdated}
                />
                <ConnectionRunStatusGridDashboard />
                <ConnectionRunStatusGrid />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  periods: periodsSelector(state),
  period: state.shared.period,
  connections: connectionsOptionsSelector(state),
  connection: state.shared.connection,
  lastUpdated: state.dashboard.connectionRunStatus.lastUpdated,
});

export default connect(
  mapStateToProps,
  {
    fetchInitialDataForConnectionRunStatusPage,
    selectPeriodForConnectionRunStatus,
    selectConnectionForConnectionRunStatus,
    fetchHeartbeatMonitorStatus,
  }
)(ConnectionRunStatusDashboardPage);
